<template>
  <div>
    <v-select v-model="odabranaUsluga"
              :items="PopisUsluga"
              item-text="ImeObrazovanja"
              return-object
              item-value="UpisPoId"
              @change="odabir(odabranaUsluga)"
              :label="$t('program_deadline.available_services')"></v-select>
  </div>
</template>

<script>
  export default {
    name: 'SelectEducation',

    props: {
      PopisUsluga: { type: Array },
      odabir: { type: Function },
    },
    computed: {
      
    },

    data() {
      return {
        odabranaUsluga: {
         // return-object kaže da ćemo vratiti cijeli objekt
        }

      }
    },

    mounted() {
      
    },

    methods: {

    }

  }
</script>



// WEBPACK FOOTER //
// VueSrc/Education/program_deadline_components/SelectEducation.vue